import { gql } from "@stadium/services/apollo-client";

export const fetchStoreNumberFromSlug = gql`
  query StoreNumberFromSlug($slug: String!) {
    store(code: $slug) {
      number
    }
  }
`;
